module.exports = __webpack_public_path__ + "img/bottomImg.7308d469.png";